import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AddJwtHeaderInterceptor } from '@interceptors/add-jwt-header/1.0';
import { AddTenantHeaderInterceptor } from '@interceptors/add-tenant-header/1.0';
import { BaseApiUrlInterceptor, BASE_API_URL, PGAAS_API_URL } from '@interceptors/base-api-url/1.0';
// import { HttpCachingInterceptor } from '@interceptors/http-caching/http-caching.interceptor';
// import { PermissionInterceptor } from '@interceptors/permission/1.0';
import { TranslateIsoHoursInterceptor } from '@interceptors/translate-iso-hours/1.0/translate-iso-hours.interceptor';
import { TrimStringSpacesInterceptor } from '@interceptors/trim-string-spaces/1.0/trim-string-spaces.interceptor';
import { environment } from '../environments/environment';
import { PUBLIC_PGAAS_API_URL } from '@interceptors/base-api-url/1.0/config';

@NgModule({
  exports: [],
  imports: [],
  providers: [
    { provide: BASE_API_URL, useValue: environment.baseApi },
    { provide: PGAAS_API_URL, useValue: environment.pgaasApi },
    { provide: PUBLIC_PGAAS_API_URL, useValue: environment.publicPgaasApi },
    // { provide: HTTP_INTERCEPTORS, useClass: PermissionInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BaseApiUrlInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AddJwtHeaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AddTenantHeaderInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: HttpCachingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TranslateIsoHoursInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TrimStringSpacesInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppHttpModule {}
